<template>
  <el-dialog
    :title="title"
    :visible.sync="trans_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="addressWrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="260px">
        <el-row>
          <el-col>
            <el-form-item prop="metricsYear" label="年份">
              <el-date-picker
                :disabled="!!this.id"
                v-model="form.metricsYear"
                type="year"
                placeholder="选择年份"
                value-format="yyyy"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="licenseCount" label="专利许可数量(件)">
              <el-input-number
                v-model="form.licenseCount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="licenseTotalAmount" label="专利许可总金额(万元)">
              <el-input-number
                v-model="form.licenseTotalAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transferCount" label="专利转让数量(件)">
              <el-input-number
                v-model="form.transferCount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transferTotalAmount" label="专利转让总金额(万元)">
              <el-input-number
                v-model="form.transferTotalAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="licensedPatentsCount" label="被许可专利数量(件)">
              <el-input-number
                v-model="form.licensedPatentsCount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="acquiredPatentsCount" label="受让专利数量(含购买、作价入股)(件)">
              <el-input-number
                v-model="form.acquiredPatentsCount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label-width="650px"
              prop="industrializedPatentsCount"
              label="专利产业化情况(用于生产出产品并投放于市场的专利件数，包括自实施和许可他人实施的)(件)"
            >
              <el-input-number
                v-model="form.industrializedPatentsCount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="securitizedPatentsCount" label="证券化专利数量(件)">
              <el-input-number
                v-model="form.securitizedPatentsCount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="securitizationAmount" label="证券化金额(万元)">
              <el-input-number
                v-model="form.securitizationAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              prop="otherLoanAmount"
              label-width="500px"
              label="其他方式贷款金额(知识产权质押融资外其他方式贷款、外部投资等)(万元)"
            >
              <el-input-number
                v-model="form.otherLoanAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="externalInvestmentAmount" label="外部投资金额(万元)">
              <el-input-number
                v-model="form.externalInvestmentAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="patentPledgeLoanAmount" label="专利质押融资贷款金额(万元)">
              <el-input-number
                v-model="form.patentPledgeLoanAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="trademarkPledgeLoanAmount" label="商标质押融资贷款金额(万元)">
              <el-input-number
                v-model="form.trademarkPledgeLoanAmount"
                :controls="false"
                style="width:100%"
                :min="0"
                :max="9999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align:center;" class="mt30">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { transSave, transUpdate, transView } from "@/api/index";
export default {
  props: {
    trans_dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "新增",
      form: {
        metricsYear: null,
        licenseCount: undefined,
        licenseTotalAmount: undefined,
        transferCount: undefined,
        transferTotalAmount: undefined,
        licensedPatentsCount: undefined,
        acquiredPatentsCount: undefined,
        industrializedPatentsCount: undefined,
        securitizedPatentsCount: undefined,
        securitizationAmount: undefined,
        otherLoanAmount: undefined,
        externalInvestmentAmount: undefined,
        patentPledgeLoanAmount: undefined,
        trademarkPledgeLoanAmount: undefined
      },
      rules: {
        metricsYear: [
          { required: true, message: "请选择年份", trigger: "change" }
        ],
        licenseCount: [
          { required: true, validator: this.$reg.integer, trigger: "blur" }
        ],
        licenseTotalAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ],
        transferCount: [
          { required: true, validator: this.$reg.integer, trigger: "blur" }
        ],
        transferTotalAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ],
        licensedPatentsCount: [
          { required: true, validator: this.$reg.integer, trigger: "blur" }
        ],
        acquiredPatentsCount: [
          { required: true, validator: this.$reg.integer, trigger: "blur" }
        ],
        industrializedPatentsCount: [
          { required: true, validator: this.$reg.integer, trigger: "blur" }
        ],
        securitizedPatentsCount: [
          { required: true, validator: this.$reg.integer, trigger: "blur" }
        ],
        securitizationAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ],
        otherLoanAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ],
        externalInvestmentAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ],
        patentPledgeLoanAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ],
        trademarkPledgeLoanAmount: [
          { required: true, validator: this.$reg.realnumber, trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    if (this.id) {
      this.title = "修改";
      transView(this.id).then(res => {
        this.form = { ...res.data, metricsYear: String(res.data.metricsYear) };
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:trans_dialogVisible", false);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            //修改
            transUpdate({
              ...this.form,
              metricsYear: Number(this.form.metricsYear)
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.$emit("update:trans_dialogVisible");
                this.$emit("refresh");
              }
            });
          } else {
            //新增
            transSave({
              ...this.form,
              metricsYear: Number(this.form.metricsYear)
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.$emit("update:trans_dialogVisible");
                this.$emit("refresh");
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>